import { disablePageScroll, enablePageScroll } from 'scroll-lock';


function burger(){
    const hamburger = document.querySelector('.burger');
    const menuLinks = document.querySelectorAll('.nav__list li');
    const menu=document.querySelector('.nav__inner');
    const nav=document.querySelector('.nav');
    // const logo=document.querySelector('.header__logo');

    function mobileMenuHide() {
        hamburger.classList.remove('burger--active');
        menu.classList.remove('nav__inner--active');
        nav.classList.remove('nav__wrap--active');
        // logo.classList.remove('header__logo--active');

        const $scrollableElement = document.querySelector('.nav__inner--active');
        enablePageScroll($scrollableElement);
    }

    function mobileMenuShow() {
        hamburger.classList.add('burger--active');
        menu.classList.add('nav__inner--active');
        nav.classList.add('nav__wrap--active');
        // logo.classList.add('header__logo--active');

        const $scrollableElement = document.querySelector('.nav__inner--active');
        disablePageScroll($scrollableElement);
    }

    hamburger.addEventListener('click', mobileMenu);

    // function mobileMenuLinkClick() {
    //     menuLinks.forEach(link => {
    //         link.addEventListener('click', () => {
    //             mobileMenuHide();
    //         });
    //     });
    // }
    // mobileMenuLinkClick();

    function mobileMenu() {

        if(!hamburger.classList.contains('burger--active')) {
            mobileMenuShow();
        } else {
            mobileMenuHide();
        }
    }

    window.addEventListener('resize', () => {
        if(window.innerWidth > 1024) {
        nav.classList.remove('nav__wrap--active');
        menu.classList.remove('nav__inner--active');
        hamburger.classList.remove('burger--active');
        // logo.classList.remove('header__logo--active');
        }
    });

}

module.exports = burger;        